<div [id]="id" bsModal #modalControl="bs-modal" [config]="config" class="modal fade" role="dialog"
  (onHidden)="onHidden()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" [ngClass]="{'hide-mobile': hideHeaderMobile}">
        <a *ngIf="showClose" (click)="HideModalDialog($event)"> <i class="icon-close pull-right" data-dismiss="modal"
            aria-label="Close"></i> </a>
        <div>
          <h3 id="title" class="title text-green text-center">{{title}}</h3>
          <p id="subtitle" class="text-center" *ngIf="title">
            <span id="line-breaker"></span>
          </p>
        </div>
      </div>
      <ng-content select=".modal-header"></ng-content>
      <ng-content select=".modal-body"></ng-content>
      <ng-content select=".modal-footer"></ng-content>
    </div>
  </div>
</div>